export default __webpack_public_path__ + "static/media/AE.c17c80ff.svg";